import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const VideoDisabled = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.53 2.908a.75.75 0 1 0-1.06 1.06l1.112 1.113A2.75 2.75 0 0 0 2.25 7.438v10A2.75 2.75 0 0 0 5 20.188h8a2.75 2.75 0 0 0 2.75-2.75v-.19l4.72 4.72a.75.75 0 1 0 1.06-1.06L5.537 4.915 5.523 4.9zm1.19 3.311a1.25 1.25 0 0 0-.97 1.219v10c0 .69.56 1.25 1.25 1.25h8c.69 0 1.25-.56 1.25-1.25v-1.69zM10 4.688a.75.75 0 1 0 0 1.5h3c.69 0 1.25.56 1.25 1.25v3.006a.75.75 0 0 0 1.092.668l.366-.189.003-.002.177-.089 2-1 2-1a.25.25 0 0 1 .362.224v7.382a.75.75 0 0 0 1.5 0V9.056a1.75 1.75 0 0 0-2.533-1.565l-2 1-1.467.733V7.438A2.75 2.75 0 0 0 13 4.688z'
        fill='currentColor'
      />
    ) : (
      <g>
        <path
          d='M3.53 2.47a.75.75 0 0 0-1.06 1.06l1.112 1.113A2.75 2.75 0 0 0 2.25 7v10A2.75 2.75 0 0 0 5 19.75h8A2.75 2.75 0 0 0 15.75 17v-.19l4.72 4.72a.75.75 0 1 0 1.06-1.06l-4.732-4.732L5.311 4.25z'
          fill='currentColor'
        />
        <path
          d='M21.75 15.382c0 .318-.047.52-.15.672-.249.371-.816.226-1.129-.093L9.833 5.1a.5.5 0 0 1 .357-.85H13A2.75 2.75 0 0 1 15.75 7v1.786l3.467-1.733a1.75 1.75 0 0 1 2.533 1.565z'
          fill='currentColor'
        />
      </g>
    )}
  </IconBase>
);
